
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './gerunds-infinitives-explanation';
const mainimage = '/Images/gerunds1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "gerundsinfinitives" },
];


const GerundsInfinitives = () => (
  <GrammarPageLayout
    level="B1"
    title="Gerunds and Infinitives"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Gerunds and Infinitives Exercises"
    seoDescription="Choose between -ing forms and to + infinitive, including verbs where the meaning changes completely. B1 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default GerundsInfinitives;
